import React from 'react';

export const AvatarCircle: React.FC<{
  src?: string | null;
  name?: string | null;
  className?: string;
  imgClassName?: string;
  fallbackBgClassName?: string;
  fallbackTextClassName?: string;
  alt?: string;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  title?: string;
}> = ({
  src,
  name,
  className,
  imgClassName,
  fallbackBgClassName,
  fallbackTextClassName,
  alt,
  onClick,
  title,
}) => {
  const [failed, setFailed] = React.useState(false);

  const safeName = String(name || '').trim();
  const letter = (safeName[0] || '').toUpperCase();

  const safeSrc = typeof src === 'string' ? src.trim() : '';
  const showImg = !!safeSrc && !failed;

  return (
    <div
      className={
        `rounded-full overflow-hidden flex items-center justify-center ${
          showImg ? 'bg-gray-200' : (fallbackBgClassName || 'bg-brand-600')
        } ${className || ''}`.trim()
      }
      onClick={onClick}
      title={title}
      aria-label={alt || safeName || 'avatar'}
      role={onClick ? 'button' : undefined}
    >
      {showImg ? (
        <img
          src={safeSrc}
          alt={alt || safeName}
          className={(`w-full h-full object-cover ${imgClassName || ''}`).trim()}
          onError={() => setFailed(true)}
        />
      ) : (
        <span className={(fallbackTextClassName || 'text-white font-medium').trim()}>{letter}</span>
      )}
    </div>
  );
};
